import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import { loadSavedSearches } from '../store/actions/saved_searches';
import { hasSearches, isLoading } from '../store/selectors/saved_searches';
import { mapIsDrawn } from '../store/selectors/coordinates';

import PropertiesSavedSearchList from './saved_search_list';
import SavedSearchPopover from './saved_search_popover';
import { filtersApplied } from '../store/selectors/query';

export class ResearchSavedSearchTopbar extends React.Component {
  static propTypes = {
    canLoad: PropTypes.bool,
    canSave: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    loadSavedSearches: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canLoad: false,
  };

  componentDidMount() {
    this.props.loadSavedSearches();
  }

  render() {
    return (
      <div className="action-links vertical-center">
        {this.renderSaveLink()}
        {this.renderLoadLink()}
      </div>
    );
  }

  renderLoadLink() {
    const { canLoad } = this.props;

    const overlay = (
      <Popover id="research-load-search-popover">
        <h4 className="bold">Load a Saved Search</h4>
        <PropertiesSavedSearchList />
      </Popover>
    );

    if (canLoad) {
      return (
        <OverlayTrigger overlay={overlay} placement="bottom" rootClose trigger="click">
          <span className="clickable">Load Search</span>
        </OverlayTrigger>
      );
    } else {
      return <span className="text-muted">Load Search</span>;
    }
  }

  renderSaveLink() {
    const { canSave } = this.props;
    const overlay = (
      <Popover className="pb-3" id="research-save-search-popover">
        <SavedSearchPopover />
      </Popover>
    );

    if (canSave) {
      return (
        <OverlayTrigger overlay={overlay} placement="bottom" rootClose trigger="click">
          <span className="clickable">Save Search</span>
        </OverlayTrigger>
      );
    } else {
      return <span className="text-muted">Save Search</span>;
    }
  }
}

const mapStateToProps = state => ({
  canLoad: hasSearches(state),
  canSave: filtersApplied(state) || mapIsDrawn(state),
  loading: isLoading(state),
});

const mapDispatchToProps = {
  loadSavedSearches
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchSavedSearchTopbar);
